import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FilterIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Filter",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M3.75 27.07H9v.58c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75v-4.68c0-.97-.78-1.75-1.75-1.75S9 22 9 22.97v.63H3.75c-.97 0-1.75.78-1.75 1.75s.78 1.75 1.75 1.75zm24.47-3.47H14.81v3.5h13.41c.97 0 1.75-.78 1.75-1.75s-.78-1.75-1.75-1.75M3.75 17.74h15.74v.69c0 .9.73 1.64 1.64 1.64h.22c.9 0 1.64-.73 1.64-1.64v-4.88c0-.9-.73-1.64-1.64-1.64h-.22c-.9 0-1.64.73-1.64 1.64v.69H3.75c-.97 0-1.75.78-1.75 1.75s.78 1.75 1.75 1.75m24.47-3.5h-2.88v3.5h2.91c.97 0 1.75-.78 1.75-1.75s-.78-1.75-1.75-1.75zM3.75 8.43H9v.69c0 .9.73 1.64 1.64 1.64h.22c.9 0 1.64-.73 1.64-1.64V4.24c0-.9-.73-1.64-1.64-1.64h-.22C9.74 2.6 9 3.33 9 4.24v.65H3.75C2.78 4.89 2 5.67 2 6.64s.78 1.75 1.75 1.75zm11.07-3.54v3.54h13.41c.97 0 1.75-.78 1.75-1.75s-.78-1.75-1.75-1.75z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M30.71 16.86H13.57a1.14 1.14 0 1 1 0-2.28h17.14a1.14 1.14 0 1 1 0 2.28M6.71 16.86H1a1.14 1.14 0 1 1 0-2.28h5.71a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.14 20.29c-2.52 0-4.57-2.05-4.57-4.57s2.05-4.57 4.57-4.57 4.57 2.05 4.57 4.57-2.05 4.57-4.57 4.57m0-6.86c-1.26 0-2.29 1.03-2.29 2.29s1.03 2.29 2.29 2.29 2.29-1.03 2.29-2.29-1.03-2.29-2.29-2.29M6.71 6.57H1a1.14 1.14 0 1 1 0-2.28h5.71a1.14 1.14 0 1 1 0 2.28M30.71 6.57H25a1.14 1.14 0 1 1 0-2.28h5.71a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M18.14 6.57H1a1.14 1.14 0 1 1 0-2.28h17.14a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.57 10C19.05 10 17 7.95 17 5.43S19.05.86 21.57.86s4.57 2.05 4.57 4.57S24.09 10 21.57 10m0-6.86c-1.26 0-2.29 1.03-2.29 2.29s1.03 2.29 2.29 2.29 2.29-1.03 2.29-2.29-1.03-2.29-2.29-2.29M30.71 27.14H25a1.14 1.14 0 1 1 0-2.28h5.71a1.14 1.14 0 1 1 0 2.28M18.14 27.14H1a1.14 1.14 0 1 1 0-2.28h17.14a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.57 30.57C19.05 30.57 17 28.52 17 26s2.05-4.57 4.57-4.57 4.57 2.05 4.57 4.57-2.05 4.57-4.57 4.57m0-6.86c-1.26 0-2.29 1.03-2.29 2.29s1.03 2.29 2.29 2.29 2.29-1.03 2.29-2.29-1.03-2.29-2.29-2.29"
      })]
    })
  }));
};